import allIndia from "./allIndia";
import allStates from "./allStates";

const rootReducer = {
  allIndia,
  allStates,
};
export default rootReducer;
